module.exports = __webpack_public_path__ + "static/img/bg_index_about_right.909c398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_index_about_right.png
// module id = yced
// module chunks = 1